import { ReactNode } from "react";

type PageSectionCardProps = {
  titleId: string;
  eyebrow: string;
  title: string;
  lead?: string;
  actions?: ReactNode;
  stickyHeader?: boolean;
  children?: ReactNode;
};

function PageSectionCard({
  titleId,
  eyebrow,
  title,
  lead,
  actions,
  stickyHeader = false,
  children,
}: PageSectionCardProps) {
  return (
    <section className="contentCard" aria-labelledby={titleId}>
      {actions ? (
        <div
          className={
            stickyHeader ? "cardHeaderRow cardHeaderRowSticky" : "cardHeaderRow"
          }
        >
          <div>
            <p className="eyebrow">{eyebrow}</p>
            <h2 id={titleId}>{title}</h2>
            {lead ? <p className="lead">{lead}</p> : null}
          </div>
          {actions}
        </div>
      ) : (
        <>
          <p className="eyebrow">{eyebrow}</p>
          <h2 id={titleId}>{title}</h2>
          {lead ? <p className="lead">{lead}</p> : null}
        </>
      )}

      {children}
    </section>
  );
}

export default PageSectionCard;
